// third-party
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// project-imports
import chat from './chat';
import calendar from './calendar';
import menu from './menu';
import snackbar from './snackbar';
import productReducer from './product';
import categoryReducer from './category';
import cartReducer from './cart';
import kanban from './kanban';
import invoice from './invoice';
import stateReducer from './state';

// ==============================|| COMBINE REDUCERS ||============================== //

const reducers = combineReducers({
  chat,
  calendar,
  menu,
  snackbar,
  cart: persistReducer(
    {
      key: 'cart',
      storage,
      keyPrefix: 'able-pro-material-ts-'
    },
    cartReducer
  ),
  category: categoryReducer,
  product: productReducer,
  kanban,
  invoice,
  state: persistReducer(
    {
      key: 'state',
      storage,
      keyPrefix: 'able-pro-material-ts-'
    },
    stateReducer
  ),
});

export default reducers;
